module.exports = __webpack_public_path__ + "static/media/Group 37.790e1607.svg";